import { noteService } from '../../services'

// initial state
const state = () => ({
    notes: [],
    note: null
})

// actions
const actions = {
    getNotes({ commit }, eventId) {
        noteService.getNotes(eventId)
            .then(
                notes => {
                    commit('getNotesSuccess', notes);
                },
                error => {
                    commit('getNotesFailure', error);
                }
            );
    },
    getNote({ commit }, noteId) {
        noteService.getNote(noteId)
            .then(
                note => {
                    commit('noteSuccess', note);
                },
                error => {
                    commit('noteFailure', error);
                }
            );
    },
    createNote({ commit }, noteData) {
        noteService.createNote(noteData)
            .then(
                note => {
                    commit('noteSuccess', note);
                },
                error => {
                    commit('noteFailure', error);
                }
            );
    },
    updateNote({ commit }, {noteId, noteData}) {
        noteService.updateNote(noteId, noteData)
            .then(
                note => {
                    commit('noteSuccess', note);
                },
                error => {
                    commit('noteFailure', error);
                }
            );
    },
    deleteNote({ commit }, noteId) {
        noteService.deleteNote(noteId)
            .then(
                note => {
                    console.log(note);
                    commit('noteDelete', noteId);
                },
                error => {
                    commit('noteFailure', error);
                }
            );
    }
}

// mutations
const mutations = {
    getNotesSuccess(state, notes) {
        state.notes = notes
    },
    noteSuccess(state, note) {
        state.note = note
        state.notes.push(note);
    },
    getNotesFailure(state, error) {
        console.log(state, error);
    },
    noteFailure(state, error) {
        console.log(state, error);
    },
    noteDelete(state, noteId) {
        let index = state.notes.findIndex(note => note.id == noteId);
        state.notes.splice(index, 1);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}